module.exports = __webpack_public_path__ + "static/img/13.be6f6e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/eng/13.png
// module id = 7lOi
// module chunks = 0